export const ScoutCustomersEmpty = {
    scoutCustomersForClientMain: "該当するタレントがいません。",
    scoutCustomersForClientDescription: "条件を変更して検索してください。",
};


// WEBPACK FOOTER //
// ./src/config/view_const/scout_customers.ts